import { SELECCIONAR_EMPRESA, DESELECCIONAR_EMPRESA, CONTAR_VENTAS_PENDIENTES, CONTAR_SUGERENCIAS_PENDIENTES, CONTAR_EVALUACIONES_PROVEEDOR_PENDIENTES, CAMBIAR_IMPRESORA } from '../actions/empresa'

const initialState = {
    id: null,
    nombre: null,
    rfc: null,
    certificada: null,
    certificadaDM: null,
    automatica: null,
    envios: null,
    embarques: null,
    fletes: null,
    marbetes: null,
    complementoDetallista: null,
    complementoSeriesPersonalizadas: null,
    insumosXCliente: null,
    modulosMezcal: null,
    modulosConsignaciones: null,
    equipoMedico: null,
    taxidermia: null,
    comodatoFechaEntregaObligatoria: null,
    conteos: false,
    cotizadorPorInsumo: null,
    ventaOnline: null,
    appMovil: false,
    checadaRemota: false,
    verificacionFacial: false,
    lotesCaducidades: null,
    filtrosAvanzadosInsumos: null,
    cargarXmlPrevio: null,
    puntoDeVenta: null,
    activarPagare: null,
    cuentaVentasPendientes: 0,
    cuentaSugerenciasPendientes: 0,
    cuentaEvaluacionesProveedorPendientes: 0,
    duplicarVentas: false,
    impresoraSeleccionada: null,
    programarRecordatorioCxC: false,
    nomina: false,
    controlAsistencia: false,
    workbenchRequisiciones : false,
    mostrarSugerenciasRequisicion: false,
    moduloCalidad: false,
    crm : false,
    evaluacionProveedores: false,
    whatsapp: false,
    whatsappNumeroPorUsuario: false,
    mostrarPdfMovimientosInventario: false,
    decimalesEmpresa: null,
    escuela: false,
    camposCalidad: null,
    consultarProveedoresOnline: false,
    quitarImpuestosOpcionalVentas: false,
    desactivarCargaExcelInsumosVentas: false,
    prorrateoDesCostos: false,
    mostrarComplementoPagoFacturas: false,
    vencimientoDesdeRecepcionFactura: false,
    anticipos: false,
    permitirCambiarClienteVenta: false,
    permitirCambiarInsumoVenta: false,
    permitirBajaLotesReemplazoVentas: false,
    permitirEditarRemisionVenta: false,
    permitirDividirVentaPorPartidas: false,
    autorizacionesRapidas: false,
    moduloWms: false,
    moduloActivosFijos: false,
    moduloCMMS: false,
    moduloHoteleria: false,
    moduloRMA: false,
    moduloProduccion: true,
    moduloBOM: true,
    transporte: true,
    portalClientes: true,
    creditos: true,
    moduloRMACompras: false,
    cerrarPedidos: false,
    finiquitarPedidos: false,
    semanaPedidos: false,
    apartarInsumosPedidos: false,
    pdfApartadoPedido: false,
    entregarInsumosPedidos: false,
    generarRequisicionPedidos: false,
    importarPedidosIMSS: false,
    editarCotizacionesTerminadas: false,
    finiquitarCotizaciones: false,
    formatoRequerimientoCotizaciones: false,
    editarTodasLasPolizas: false,
    verPolizaAlRealizarMovimiento: false,
    buscadorMenu: true,
    verComoSistemaOCPorDefecto: false,
    imprimirObservacionesOCPorDefecto: false,
    separacionInsumosSimpleOC: false,
    separacionInsumosPorClienteOC: false,
    separacionInsumosPorDiaOC: false,
    complementoPSWPedidos: false,
    preCotizacionIngenieria: false,
    ordenesMaquila: false,
    activarEtiquetaEntregaPedido: false,
    unidadTiempoProduccion: "minutos",
    altaEmpleadoPorPasos: false,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECCIONAR_EMPRESA:
            return {
                id: action.data.id,
                nombre: action.data.nombre,
                rfc: action.data.rfc,
                certificada: action.data.certificada ? action.data.certificada : false,
                certificadaDM: action.data.certificadaDM ? action.data.certificadaDM : false,
                automatica: action.data.automatica ? action.data.automatica : false,
                envios: action.data.envios ? action.data.envios : false,
                embarques: action.data.embarques ? action.data.embarques : false,
                fletes: action.data.fletes ? action.data.fletes : false,
                marbetes: action.data.marbetes ? action.data.marbetes : false,
                complementoDetallista: action.data.complementoDetallista ? action.data.complementoDetallista : false,
                complementoSeriesPersonalizadas: action.data.complementoSeriesPersonalizadas ? action.data.complementoSeriesPersonalizadas : false,
                insumosXCliente: action.data.insumosXCliente ? action.data.insumosXCliente : false,
                cargarXmlPrevio: action.data.cargarXmlPrevio ? action.data.cargarXmlPrevio : false,
                activarPagare: action.data.activarPagare ? action.data.activarPagare : false,
                modulosMezcal: action.data.modulosMezcal ? action.data.modulosMezcal : false,
                modulosConsignaciones: action.data.modulosConsignaciones ? action.data.modulosConsignaciones : false,
                equipoMedico: action.data.equipoMedico ? action.data.equipoMedico : false,
                taxidermia: action.data.taxidermia ? action.data.taxidermia : false,
                comodatoFechaEntregaObligatoria: action.data.comodatoFechaEntregaObligatoria ? action.data.comodatoFechaEntregaObligatoria : false,
                conteos: action.data.conteos ? action.data.conteos : false,
                puntoDeVenta: action.data.puntoDeVenta ? action.data.puntoDeVenta : false,
                lotesCaducidades: action.data.lotesCaducidades ? action.data.lotesCaducidades : false,
                filtrosAvanzadosInsumos: action.data.filtrosAvanzadosInsumos ? action.data.filtrosAvanzadosInsumos : false,
                duplicarVentas: action.data.duplicarVentas ? action.data.duplicarVentas : false,
                programarRecordatorioCxC: action.data.programarRecordatorioCxC ? action.data.programarRecordatorioCxC : false,
                cotizadorPorInsumo: action.data.cotizadorPorInsumo ? action.data.cotizadorPorInsumo : false,
                ventaOnline: action.data.ventaOnline ? action.data.ventaOnline : false,
                appMovil: action.data.appMovil ? action.data.appMovil : false,
                checadaRemota: action.data.checadaRemota ? action.data.checadaRemota : false,
                verificacionFacial: action.data.verificacionFacial ? action.data.verificacionFacial : false,
                nomina: action.data.nomina ? action.data.nomina : false,
                controlAsistencia: action.data.controlAsistencia ? action.data.controlAsistencia : false,
                workbenchRequisiciones: action.data.workbenchRequisiciones ? action.data.workbenchRequisiciones : false,
                mostrarSugerenciasRequisicion: action.data.mostrarSugerenciasRequisicion ? action.data.mostrarSugerenciasRequisicion : false,
                moduloCalidad: action.data.moduloCalidad ? action.data.moduloCalidad : false,
                crm : action.data.crm ? action.data.crm : false,
                evaluacionProveedores: action.data.evaluacionProveedores ? action.data.evaluacionProveedores : false,
                whatsapp: action.data.whatsapp ? action.data.whatsapp : false,
                whatsappNumeroPorUsuario: action.data.whatsappNumeroPorUsuario ? action.data.whatsappNumeroPorUsuario : false,
                mostrarPdfMovimientosInventario: action.data.mostrarPdfMovimientosInventario ? action.data.mostrarPdfMovimientosInventario : false,
                decimalesEmpresa: action.data.decimalesEmpresa ? action.data.decimalesEmpresa : null,
                escuela: action.data.escuela ? action.data.escuela : false,
                camposCalidad: action.data.camposCalidad ?? null,
                consultarProveedoresOnline: action.data.consultarProveedoresOnline ? action.data.consultarProveedoresOnline : false,
                quitarImpuestosOpcionalVentas: action.data.quitarImpuestosOpcionalVentas ? action.data.quitarImpuestosOpcionalVentas : false,
                desactivarCargaExcelInsumosVentas: action.data.desactivarCargaExcelInsumosVentas ? action.data.desactivarCargaExcelInsumosVentas : false,
                prorrateoDesCostos: action.data.prorrateoDesCostos ? action.data.prorrateoDesCostos : false,
                mostrarComplementoPagoFacturas: action.data.mostrarComplementoPagoFacturas ? action.data.mostrarComplementoPagoFacturas : false,
                vencimientoDesdeRecepcionFactura: action.data.vencimientoDesdeRecepcionFactura === true,
                anticipos: action.data.anticipos ? action.data.anticipos : false,
                permitirCambiarClienteVenta: action.data.permitirCambiarClienteVenta ? action.data.permitirCambiarClienteVenta : false,
                permitirCambiarInsumoVenta: action.data.permitirCambiarInsumoVenta ? action.data.permitirCambiarInsumoVenta : false,
                permitirBajaLotesReemplazoVentas: action.data.permitirBajaLotesReemplazoVentas === true,
                permitirEditarRemisionVenta: action.data.permitirEditarRemisionVenta ? action.data.permitirEditarRemisionVenta : false,
                permitirDividirVentaPorPartidas: action.data.permitirDividirVentaPorPartidas ? action.data.permitirDividirVentaPorPartidas : false,
                autorizacionesRapidas: action.data.autorizacionesRapidas ? action.data.autorizacionesRapidas : false,
                moduloWms: action.data.moduloWms ? action.data.moduloWms : false,
                moduloActivosFijos: action.data.moduloActivosFijos ? action.data.moduloActivosFijos : false,
                moduloCMMS: action.data.moduloCMMS ? action.data.moduloCMMS : false,
                moduloHoteleria: action.data.moduloHoteleria ? action.data.moduloHoteleria : false,
                moduloRMA: action.data.moduloRMA ? action.data.moduloRMA : false,
                moduloProduccion: action.data.moduloProduccion !== false,
                moduloBOM: action.data.moduloBOM !== false,
                transporte: action.data.transporte !== false,
                portalClientes: action.data.portalClientes !== false,
                creditos: action.data.creditos !== false,
                moduloRMACompras: action.data.moduloRMACompras ? action.data.moduloRMACompras : false,
                cerrarPedidos: action.data.cerrarPedidos ? action.data.cerrarPedidos : false,
                finiquitarPedidos: action.data.finiquitarPedidos ? action.data.finiquitarPedidos : false,
                semanaPedidos: action.data.semanaPedidos ? action.data.semanaPedidos : false,
                apartarInsumosPedidos: action.data.apartarInsumosPedidos ? action.data.apartarInsumosPedidos : false,
                pdfApartadoPedido: action.data.pdfApartadoPedido ? action.data.pdfApartadoPedido : false,
                entregarInsumosPedidos: action.data.entregarInsumosPedidos ? action.data.entregarInsumosPedidos : false,
                generarRequisicionPedidos: action.data.generarRequisicionPedidos ? action.data.generarRequisicionPedidos : false,
                importarPedidosIMSS: action.data.importarPedidosIMSS ? action.data.importarPedidosIMSS : false,
                editarCotizacionesTerminadas: action.data.editarCotizacionesTerminadas ? action.data.editarCotizacionesTerminadas : false,
                finiquitarCotizaciones: action.data.finiquitarCotizaciones ? action.data.finiquitarCotizaciones : false,
                formatoRequerimientoCotizaciones: action.data.formatoRequerimientoCotizaciones === true,
                editarTodasLasPolizas: action.data.editarTodasLasPolizas ? action.data.editarTodasLasPolizas : false,
                verPolizaAlRealizarMovimiento: action.data.verPolizaAlRealizarMovimiento ? action.data.verPolizaAlRealizarMovimiento : false,
                buscadorMenu: true,
                verComoSistemaOCPorDefecto: action.data.verComoSistemaOCPorDefecto ? action.data.verComoSistemaOCPorDefecto : false,
                imprimirObservacionesOCPorDefecto: action.data.imprimirObservacionesOCPorDefecto ? action.data.imprimirObservacionesOCPorDefecto : false,
                separacionInsumosSimpleOC: action.data.separacionInsumosSimpleOC ? action.data.separacionInsumosSimpleOC : false,
                separacionInsumosPorClienteOC: action.data.separacionInsumosPorClienteOC ? action.data.separacionInsumosPorClienteOC : false,
                separacionInsumosPorDiaOC: action.data.separacionInsumosPorDiaOC ? action.data.separacionInsumosPorDiaOC : false,
                complementoPSWPedidos: action.data.complementoPSWPedidos ? action.data.complementoPSWPedidos : false,
                preCotizacionIngenieria: action.data.preCotizacionIngenieria ? action.data.preCotizacionIngenieria : false,
                ordenesMaquila: !!(action.data.preCotizacionIngenieria && action.data.ordenesMaquila),
                activarEtiquetaEntregaPedido: action.data.activarEtiquetaEntregaPedido ? action.data.activarEtiquetaEntregaPedido : false,
                cuentaVentasPendientes: 0,
                cuentaSugerenciasPendientes: 0,
                cuentaEvaluacionesProveedorPendientes: 0,
                impresoraSeleccionada: null,
                unidadTiempoProduccion: action.data.unidadTiempoProduccion === "horas" ? "horas" : "minutos",
                altaEmpleadoPorPasos: action.data.altaEmpleadoPorPasos === true,
            }
        case DESELECCIONAR_EMPRESA:
            return {
                id: null,
                nombre: null,
                rfc: null,
                certificada: null,
                certificadaDM: null,
                automatica: null,
                envios: null,
                embarques: null,
                fletes: null,
                marbetes: null,
                complementoDetallista: null,
                complementoSeriesPersonalizadas: null,
                insumosXCliente: null,
                cargarXmlPrevio: null,
                activarPagare: null,
                modulosMezcal: null,
                modulosConsignaciones: null,
                equipoMedico: null,
                taxidermia: null,
                comodatoFechaEntregaObligatoria: null,
                conteos: false,
                lotesCaducidades: null,
                filtrosAvanzadosInsumos: null,
                duplicarVentas: false,
                puntoDeVenta: null,
                programarRecordatorioCxC: false,
                cotizadorPorInsumo: null,
                ventaOnline: null,
                appMovil: false,
                checadaRemota: false,
                verificacionFacial: false,
                nomina: false,
                controlAsistencia: false,
                workbenchRequisiciones : false,
                mostrarSugerenciasRequisicion: false,
                moduloCalidad: false,
                crm : false,
                evaluacionProveedores: false,
                whatsapp: false,
                whatsappNumeroPorUsuario: false,
                escuela: false,
                mostrarPdfMovimientosInventario: false,
                decimalesEmpresa: null,
                camposCalidad: null,
                consultarProveedoresOnline: false,
                quitarImpuestosOpcionalVentas: false,
                desactivarCargaExcelInsumosVentas: false,
                prorrateoDesCostos: false,
                mostrarComplementoPagoFacturas: false,
                vencimientoDesdeRecepcionFactura: false,
                anticipos: false,
                permitirCambiarClienteVenta: false,
                permitirCambiarInsumoVenta: false,
                permitirBajaLotesReemplazoVentas: false,
                permitirEditarRemisionVenta: false,
                permitirDividirVentaPorPartidas: false,
                autorizacionesRapidas: false,
                moduloWms: false,
                moduloActivosFijos: false,
                moduloCMMS: false,
                moduloHoteleria: false,
                moduloRMA: false,
                moduloProduccion: true,
                moduloBOM: true,
                transporte: true,
                portalClientes: true,
                creditos: true,
                moduloRMACompras: false,
                cerrarPedidos: false,
                finiquitarPedidos: false,
                semanaPedidos: false,
                apartarInsumosPedidos: false,
                pdfApartadoPedido: false,
                entregarInsumosPedidos: false,
                generarRequisicionPedidos: false,
                importarPedidosIMSS: false,
                editarCotizacionesTerminadas: false,
                finiquitarCotizaciones: false,
                formatoRequerimientoCotizaciones: false,
                editarTodasLasPolizas: false,
                verPolizaAlRealizarMovimiento: false,
                buscadorMenu: true,
                verComoSistemaOCPorDefecto: false,
                imprimirObservacionesOCPorDefecto: false,
                separacionInsumosSimpleOC: false,
                separacionInsumosPorClienteOC: false,
                separacionInsumosPorDiaOC: false,
                complementoPSWPedidos: false,
                preCotizacionIngenieria: false,
                ordenesMaquila: false,
                activarEtiquetaEntregaPedido: false,
                cuentaVentasPendientes: 0,
                cuentaSugerenciasPendientes: 0,
                cuentaEvaluacionesProveedorPendientes: 0,
                impresoraSeleccionada: null,
                unidadTiempoProduccion: "minutos",
                altaEmpleadoPorPasos: false,
            }

        case CONTAR_VENTAS_PENDIENTES:
            return {
                ...state,
                cuentaVentasPendientes: action.data.pendientes
            }
        case CONTAR_SUGERENCIAS_PENDIENTES:
            return {
                ...state,
                cuentaSugerenciasPendientes: action.data.pendientes
            }
        case CONTAR_EVALUACIONES_PROVEEDOR_PENDIENTES:
            return {
                ...state,
                cuentaEvaluacionesProveedorPendientes: action.data.pendientes
            }
        case CAMBIAR_IMPRESORA:
            return {
                ...state,
                impresoraSeleccionada: action.data.impresora
            }
        default:
            break;
    }
    return state
}

export default reducer